'use strict';

exports.__esModule = true;

var _react = require('react');

exports.default = _react.PropTypes.shape({
  theme: _react.PropTypes.object.isRequired
});


//////////////////
// WEBPACK FOOTER
// ../~/react-css-themr/lib/utils/themr-shape.js
// module id = 876
// module chunks = 0